/** Chapter 1 topics are public; chapters 2–11 require sign-in. */
export const PHALADEEPIKA_PUBLIC_CHAPTER = 1;

export const PHALADEEPIKA_LOGIN_INTENT = {
  subtitleEn: 'Sign in or register to read Phaladeepika chapters 2 and beyond.',
  subtitleHi: 'फलदीपिका अध्याय २ और आगे पढ़ने के लिए साइन इन करें या खाता बनाएँ।',
};

/**
 * @param {string | null | undefined} topicId
 * @returns {number | null}
 */
export function getPhaladeepikaChapterNumber(topicId) {
  if (!topicId || !topicId.startsWith('phaladeepika-ch')) return null;
  const match = /^phaladeepika-ch(\d+)/.exec(topicId);
  if (!match) return null;
  return Number.parseInt(match[1], 10);
}

/**
 * @param {string | null | undefined} topicId
 * @returns {boolean}
 */
export function isPhaladeepikaPublicTopic(topicId) {
  return getPhaladeepikaChapterNumber(topicId) === PHALADEEPIKA_PUBLIC_CHAPTER;
}

/**
 * @param {string | null | undefined} topicId
 * @param {object | null | undefined} user
 * @returns {boolean}
 */
export function isPhaladeepikaLoginRequired(topicId, user) {
  if (user) return false;
  const chapter = getPhaladeepikaChapterNumber(topicId);
  return chapter != null && chapter > PHALADEEPIKA_PUBLIC_CHAPTER;
}

/**
 * @param {string} chapterId e.g. "ch2"
 * @param {object | null | undefined} user
 * @returns {boolean}
 */
export function isPhaladeepikaChapterLoginRequired(chapterId, user) {
  if (user) return false;
  const match = /^ch(\d+)$/.exec(chapterId);
  if (!match) return false;
  return Number.parseInt(match[1], 10) > PHALADEEPIKA_PUBLIC_CHAPTER;
}

/** Prefix Phaladeepika section codes (1.1 → F1.1) to distinguish from syllabus lesson numbers. */
export function formatPhaladeepikaSectionCode(code) {
  if (code == null || code === '') return code;
  const str = String(code).trim();
  if (str.startsWith('F')) return str;
  if (/^\d+\.\d+$/.test(str)) return `F${str}`;
  return str;
}

/** Prefix leading chapter.section in hub/search labels (1.1 प्रार्थना → F1.1 प्रार्थना). */
export function formatPhaladeepikaSectionLabel(label) {
  if (!label || typeof label !== 'string') return label;
  return label.replace(/^(\d+\.\d+)/, 'F$1');
}

/** Prefix F chapter.section before English hub label (Prayer → F1.1 Prayer). */
export function formatPhaladeepikaEnglishSectionLabel(hiLabel, enLabel) {
  if (!enLabel) return enLabel;
  const match = /^(\d+\.\d+)/.exec(String(hiLabel || '').trim());
  if (!match) return enLabel;
  return `${formatPhaladeepikaSectionCode(match[1])} ${enLabel}`;
}

/**
 * @param {string | null | undefined} topicId
 * @param {string | null | undefined} label
 */
export function formatPhaladeepikaTopicLabel(topicId, label) {
  if (!topicId?.startsWith('phaladeepika-ch')) return label;
  return formatPhaladeepikaSectionLabel(label);
}
